import { FC, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { AboutTheRole, CanApply, Introduction, JobLike } from "../../../constants";
import { AboutTheRoleData, CanApplyData, IntroductionData, JobLikeData } from "../../../data/Job";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import { JobDetailType } from "../../../types/Product";
import Benefits from "./detailBody/detailBodyItem/Benefits";
import JobDescriptionBox from "./detailBody/detailBodyItem/JobDescriptionBox";
import DetailSidebar from "./detailSidebar";
import MainDetail from "./mainDetail";
import RelatedProduct from "./RelatedProduct";

const JobDetail: FC<JobDetailType> = ({ detailType }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
  }, [dispatch]);
  return (
    <section className={`job-detail-section section-b-space ${detailType === "style_2" ? "pt-0" : ""}`}>
      <Container>
        {detailType === "style_2" && <MainDetail type="job" detailType={detailType} />}
        <Row className="gy-lg-0 gy-4">
          <Col lg={detailType === "style_3" ? "7" : "8"} className={detailType === "style_2" || detailType === "style_5" ? "col-xl-9" : ""}>
            {(detailType === "style_4" || detailType === "style_5") && <MainDetail type="job" detailType={detailType} />}
            <div className={`job-description ${detailType === "style_3" ? "detail-style-1" : ""}`}>
              {detailType === "style_3" && <JobDescriptionBox title={Introduction} data={IntroductionData} />}
              <JobDescriptionBox title={AboutTheRole} data={AboutTheRoleData} />
              {(detailType === "style_2" || detailType === "style_3") && <Benefits />}
              <JobDescriptionBox title={JobLike} data={JobLikeData} list />
              <JobDescriptionBox title={CanApply} data={CanApplyData} list />
            </div>
          </Col>
          <DetailSidebar type="job" sliderStyle={detailType} />
        </Row>
        <RelatedProduct type="job" />
      </Container>
    </section>
  );
};

export default JobDetail;
